import { render, staticRenderFns } from "./Helptip.vue?vue&type=template&id=27f4bc26&scoped=true"
import script from "./Helptip.vue?vue&type=script&lang=js"
export * from "./Helptip.vue?vue&type=script&lang=js"
import style0 from "./Helptip.vue?vue&type=style&index=0&id=27f4bc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4bc26",
  null
  
)

export default component.exports